import { render } from "./AuditAnak.vue?vue&type=template&id=a2b95e2a&scoped=true"
import script from "./AuditAnak.vue?vue&type=script&lang=js"
export * from "./AuditAnak.vue?vue&type=script&lang=js"

import "./AuditAnak.vue?vue&type=style&index=0&id=a2b95e2a&scoped=true&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2b95e2a"]])

export default __exports__